<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "groupUsers",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "groupUsers",
          list: [],
          headers: {
            id: {
              title: "کد گروه",
              type: "text"
            },
            title: {
              title: "نام گروه",
              type: "text"
            },

          }
        },

      };
    },

  };
</script>

<style scoped>

</style>
